import { BaseModel } from './base.model';

export enum ActionType {
  LOGIN = 'login',
  APPROVE_DOCUMENT = 'approve_document',
  DECLINE_DOCUMENT = 'decline_document',
  ASSIGN_VEHICLE = 'assign_vehicle',
  UNASSIGN_VEHICLE = 'unassign_vehicle',
  APPROVE_ADDRESS = 'approve_address',
  DECLINE_ADDRESS = 'decline_address',
  APPROVE_PROFILE = 'approve_profile',
  DECLINE_PROFILE = 'decline_profile',
  CONTRACT_CREATED = 'contract_created',
  CONTRACT_UPDATED = 'contract_updated',
  CONTRACT_DELETED = 'contract_deleted',
  APPROVE_BANKING_DETAILS = 'approve_banking_details',
  DECLINE_BANKING_DETAILS = 'decline_banking_details',
}

export class Action extends BaseModel {
  userId: string = '';
  performedBy: any;
  action: ActionType | '' = '';

  documentId?: string;

  constructor(data?: Partial<DocumentType>) {
    super();
    Object.assign(this, data);
  }
}
